export default {
    setLogin(state, value) {
        state.isLogin = value
    },
    setToken(state, value) {
        state.token = value
    },
    // 设置首页数据加载状态
    setTabActive(state, value) {
        state.tabActive = value
    },
    setLoginOrReginter(state, value) {
        state.loginOrReginter = value
    },
    // 弹出登陆框
    setFormVisible(state, value) {
        state.formVisible = value
    },
    // 登陆后跳转的下一个页面
    setToRouter(state, value) {
        state.toRouter = value
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js